module.exports = __webpack_public_path__ + "static/img/logo.891b9f46.png";